import React from "react";
import Discount from "./discount";


const NestedDiscounts = (props) => {
  const {nestedDiscounts, discountSection, sectionIndex} = props;
  if (!nestedDiscounts.length) {
    return null
  }
  return (
    <ul className="discounts-section__discounts">
      {nestedDiscounts.map(disc => {
        return <Discount discount={disc}
                         key={disc.id}
                         discountSection={discountSection}
                         discountIndex={0}
                         sectionIndex={sectionIndex}/>
      })}
    </ul>
  )
};

export default NestedDiscounts
